<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <detected-speed>
          <v-alert slot="unknown" dense outlined type="warning">
            <strong>Votre connexion est anormale</strong>
          </v-alert>
          <v-alert slot="slow" dense outlined type="error">
            <strong>Votre connexion n'est pas stable</strong>
          </v-alert>
          <v-alert slot="fast" dense outlined type="success">
            <strong>Votre connexion est stable</strong>
          </v-alert>
        </detected-speed>
      </v-col>
    </v-row>

    <!-- ✅ Affichage des cartes si infoHome existe -->
    <v-row v-if="infoHome.data">
      <v-col
        v-for="(card, index) in filteredCards"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        class="pb-2"
      >
        <v-card>
          <v-row class="no-gutters">
            <div class="col-auto">
              <div :class="`${card.color} fill-height`">&nbsp;</div>
            </div>
            <div class="col pa-3 py-4" :class="`${card.color}--text`">
              <h5 class="text-truncate text-uppercase">{{ card.label }}</h5>
              <h1>{{ card.value }}</h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- ✅ Affichage par défaut (aucune donnée) -->
    <v-row v-else>
      <v-col
        v-for="(card, index) in defaultCards"
        :key="'default-' + index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        class="pb-2"
      >
        <v-card>
          <v-row class="no-gutters">
            <div class="col-auto">
              <div :class="`${card.color} fill-height`">&nbsp;</div>
            </div>
            <div class="col pa-3 py-4" :class="`${card.color}--text`">
              <h5 class="text-truncate text-uppercase">{{ card.label }}</h5>
              <h1>0</h1>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DetectedSpeed from "vue-identify-network";

export default {
  components: { DetectedSpeed },
  data: () => ({
    profile: null,
    user_data: null
  }),
  created() {
    const Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.user_data = Virt;
    this.$store.dispatch("Auth/getAllConfigHome");
  },
  computed: {
    ...mapGetters({
      infoHome: "Auth/get_all_cnfig_home"
    }),

    filteredCards() {
      if (!this.infoHome.data) return [];

      const d = this.infoHome.data;
      const p = this.profile;

      const allCards = [
        { label: "PPM", value: d.ppms, color: "cyan" },
        { label: "Avis", value: d.notices, color: "primary" },
        { label: "Dossiers", value: d.folders, color: "success" },
        { label: "Offres / Propositions / Plis", value: d.offers, color: "indigo", visible: p != 2 && p != 4 && p != 5 && p != 6 },
        { label: "Additifs", value: d.extension_addons, color: "red", visible: p != 2 && p != 4 && p != 5 },
        { label: "TDRs", value: d.extensions_tdrs, color: "orange", visible: p != 2 && p != 4 },
        { label: "Nombre d’inscrits", value: d.operators, color: "blue", visible: p != 2 && p != 4 && p != 5 && p != 6 },
        { label: "Membres de la commission", value: d.members, color: "brown", visible: p != 2 && p != 4 && p != 5 && p != 6 }
      ];

      return allCards.filter(c => c.visible !== false);
    },

    defaultCards() {
      return [
        { label: "PPM", color: "cyan" },
        { label: "Avis", color: "primary" },
        { label: "Dossiers", color: "success" }
      ];
    }
  }
};
</script>

<style scoped>
.fill-height {
  width: 8px;
}
</style>
